'use strict';

var constants = require('./util/constants'),
    Logging   = require('./mixins/logging');

var Faye = {
  VERSION:    constants.VERSION,

  Client:     require('./protocol/client'),
  Scheduler:  require('./protocol/scheduler')
};

Logging.wrapper = Faye;

module.exports = Faye;



/*****************
 ** WEBPACK FOOTER
 ** ./src/faye_browser.js
 ** module id = 0
 ** module chunks = 0
 **/